import React from 'react';
import FileSaver from 'file-saver';
import {AppContext} from './AppContext';
import * as plural from 'plural-ru';
import ym from 'react-yandex-metrika';

export default class Download extends React.Component {
  constructor(props) {
    super(props);
    this.download = this.download.bind(this);
  }

  download () {
    const firstLine = this.props.text.replace(/[",.!-::']/g , "");
    const length = firstLine.indexOf(" ", 25);
    const title = firstLine.substr(0, length > 0 ? length : 30);
    const date = new Date().toLocaleDateString();
    // Replace clean newlines with windows evil
    const text = this.props.text.replace(/([^\r])\n/g, "$1\r\n");
    const blob = new Blob([text], {type: "text/plain;charset=utf-8"});
    const filename = `${title} (Фитиль ${date}).txt`;
    FileSaver.saveAs(blob, filename);
    ym('reachGoal', 'Download');
  }

  render() {
    return (
      <AppContext.Consumer>
      { ({words}) =>
        <button onClick={ this.download } className="tiny ghost">Скачать { words || 0 } { plural(words, 'слово', 'слова', 'слов') }</button>
      }
      </AppContext.Consumer>
    )
  }
}
